import { render, staticRenderFns } from "./historialApgar.vue?vue&type=template&id=917c7042"
import script from "./historialApgar.vue?vue&type=script&lang=js"
export * from "./historialApgar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports